export interface SeoData {
  title: string;
  description: string;
  keywords?: string;
  canonical: string;
  ogType?: string;
  ogImage?: string;
  robots?: string;
}

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(
    `meta[${attr}="${key}"]`
  );
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function removeMeta(attr: "name" | "property", key: string) {
  const el = document.head.querySelector<HTMLMetaElement>(
    `meta[${attr}="${key}"]`
  );
  if (el) el.remove();
}

function upsertLink(rel: string, href: string) {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function applySeo(data: SeoData) {
  document.title = data.title;
  upsertMeta("name", "description", data.description);

  if (data.keywords) {
    upsertMeta("name", "keywords", data.keywords);
  } else {
    removeMeta("name", "keywords");
  }

  upsertLink("canonical", data.canonical);

  upsertMeta("property", "og:title", data.title);
  upsertMeta("property", "og:description", data.description);
  upsertMeta("property", "og:url", data.canonical);

  if (data.ogType) {
    upsertMeta("property", "og:type", data.ogType);
  } else {
    removeMeta("property", "og:type");
  }

  if (data.ogImage) {
    upsertMeta("property", "og:image", data.ogImage);
    upsertMeta("name", "twitter:image", data.ogImage);
  } else {
    removeMeta("property", "og:image");
    removeMeta("name", "twitter:image");
  }

  upsertMeta("name", "twitter:title", data.title);
  upsertMeta("name", "twitter:description", data.description);

  if (data.robots) {
    upsertMeta("name", "robots", data.robots);
  } else {
    removeMeta("name", "robots");
  }
}